const DATE_PREFIX = /^(\d{4}-\d{2}-\d{2})/

const pad = (n: number) => String(n).padStart(2, '0')

/** Today's calendar day in the user's timezone (not UTC). */
export function calendarToday(): string {
  const d = new Date()
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
}

/**
 * Read a calendar day from API/input without a timezone shift.
 * "2026-09-11T00:00:00" and "2026-09-11T00:00:00Z" both stay 2026-09-11.
 */
export function calendarFromApi(value?: string | Date | null): string {
  if (!value) return ''
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return ''
    return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`
  }
  const raw = String(value).trim()
  const match = raw.match(DATE_PREFIX)
  if (match) return match[1]

  const dmy = raw.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/)
  if (dmy) {
    const parsed = new Date(`${dmy[2]} ${dmy[1]}, ${dmy[3]} 12:00:00`)
    if (!Number.isNaN(parsed.getTime())) {
      return `${parsed.getFullYear()}-${pad(parsed.getMonth() + 1)}-${pad(parsed.getDate())}`
    }
  }

  return ''
}

/** Send a calendar day as UTC midnight so DateOnly keeps the same Y-M-D. */
export function calendarToApi(value?: string | Date | null): string {
  const day = calendarFromApi(value) || calendarToday()
  return `${day}T00:00:00.000Z`
}

export function formatCalendarDate(value?: string | Date | null, locale = 'en-GB'): string {
  const day = calendarFromApi(value)
  if (!day) return 'N/A'
  const date = new Date(`${day}T12:00:00`)
  return date.toLocaleDateString(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
}

export function addCalendarDays(value: string | Date | null | undefined, days: number): string {
  const day = calendarFromApi(value) || calendarToday()
  const [y, m, d] = day.split('-').map(Number)
  const date = new Date(y, m - 1, d + days)
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
}
